"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13086],{

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 813086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LazyVideoPreviewCarousel": function() { return /* reexport */ LazyVideoPreviewCarousel; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(110413);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/utils.es.js
var utils_es = __webpack_require__(916476);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/tracking/dist/interface.es.js
var interface_es = __webpack_require__(141873);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.8.0-MOBCOMMON8504.1-aac718131a-360bd50b3e.zip/node_modules/@terra-js/terra-kit/dist/index.js
var dist = __webpack_require__(68706);
// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.8.0-MOBCOMMON8504.1-aac718131a-360bd50b3e.zip/node_modules/@terra-js/terra-kit/dist/common/CommonKitModule.js
var CommonKitModule = __webpack_require__(146626);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
// EXTERNAL MODULE: ./helpers/terra.ts
var terra = __webpack_require__(632843);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
;// CONCATENATED MODULE: ./modules/page-builder/slots/VideoPreviewList/useActionButtons.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









const SINGLE_PRODUCT_QUANTITY = 1;
const useActionButtons = ()=>{
    const { allowBuyNow  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onAddSingleItem  } = (0,CartContextV2/* useCartV2 */.T6)();
    const router = (0,next_router.useRouter)();
    const toast = (0,ToastContext/* useToast */.p)();
    const handleAddToCart = async function(product) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : interface_es/* AddToCartType.ADDTOCART */.h.ADDTOCART;
        var ref, ref1, ref2;
        const trackAddToCartParams = {
            product: {
                sku: product.sellerSku || "",
                name: product.name || "",
                price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice,
                brand: {
                    name: ((ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                },
                addToCartPrice: ((ref2 = product.price) === null || ref2 === void 0 ? void 0 : ref2.supplierRetailPrice) || 0,
                sellerSku: product.sellerSku
            },
            selectedPromotionId: product.selectPromotionId,
            type
        };
        try {
            const res = await onAddSingleItem({
                sku: product.sku || "",
                sellerSku: product.sellerSku,
                quantity: SINGLE_PRODUCT_QUANTITY,
                promotionId: product.selectPromotionId !== 0 ? product.selectPromotionId : undefined
            }, true, allowBuyNow && type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW ? utils_es/* IsolatedCartType.BUY_NOW */.oG.BUY_NOW : undefined);
            if (res) {
                (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }));
            } else {
                (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }));
            }
            if (res && (type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW || type === interface_es/* AddToCartType.INSTALLMENT */.h.INSTALLMENT)) {
                const cartToken = (0,utils_es/* getCartToken */.i)();
                if (type === interface_es/* AddToCartType.BUYNOW */.h.BUYNOW && !allowBuyNow) {
                    // if open inside a webview on mobile app
                    if (!!dist/* default.isAvailable */.Z.isAvailable()) {
                        if (!!cartToken) {
                            dist/* default.order */.Z.order().navigateToCart(cartToken);
                        } else {
                            var ref3;
                            toast === null || toast === void 0 ? void 0 : (ref3 = toast.error) === null || ref3 === void 0 ? void 0 : ref3.call(toast, {
                                title: (0,i18n.t)("Error"),
                                message: (0,i18n.t)("Kh\xf4ng lấy được cart token. Vui l\xf2ng thử lại!")
                            });
                        }
                    } else {
                        router.push("/cart");
                    }
                } else {
                    // if open inside a webview on mobile app
                    if (!!dist/* default.isAvailable */.Z.isAvailable()) {
                        if (!!cartToken) {
                            terra/* default.observeOpenBuyNow */.Z.observeOpenBuyNow({
                                token: cartToken,
                                sku: product.sku || "",
                                quantity: SINGLE_PRODUCT_QUANTITY,
                                cartType: CommonKitModule.CartType.BUY_NOW
                            });
                        } else {
                            var ref4;
                            toast === null || toast === void 0 ? void 0 : (ref4 = toast.error) === null || ref4 === void 0 ? void 0 : ref4.call(toast, {
                                title: (0,i18n.t)("Error"),
                                message: (0,i18n.t)("Kh\xf4ng lấy được cart token. Vui l\xf2ng thử lại!")
                            });
                        }
                    } else {
                        const key = (0,utils_es/* getBuyNowKey */.B2)(true);
                        router.push("/checkout?bnk=".concat(key));
                    }
                }
            }
        } catch (error) {
            (0,cart_es/* trackAddToCart */.Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }));
            index_es/* logger.error */.k.error(error);
        }
    };
    const buyNow = async (product)=>{
        return handleAddToCart(product, interface_es/* AddToCartType.BUYNOW */.h.BUYNOW);
    };
    const addToCart = async (product)=>{
        return handleAddToCart(product, interface_es/* AddToCartType.ADDTOCART */.h.ADDTOCART);
    };
    return {
        buyNow,
        addToCart
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/useDiscoverySearch.es.js
var useDiscoverySearch_es = __webpack_require__(232771);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./contexts/BuildPCContextV2.tsx
var BuildPCContextV2 = __webpack_require__(39486);
// EXTERNAL MODULE: ./contexts/RelatedProductContext.tsx + 1 modules
var RelatedProductContext = __webpack_require__(725965);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
;// CONCATENATED MODULE: ./modules/page-builder/slots/VideoPreviewList/useSearchProductDiscovery.ts
function useSearchProductDiscovery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useSearchProductDiscovery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useSearchProductDiscovery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useSearchProductDiscovery_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useSearchProductDiscovery_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useSearchProductDiscovery_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const useSearchProductDiscovery = (searchPayload, fallbackData)=>{
    const { isDisplayUom , contactLink , isAllowATCFromListing , showNewProductGift , epicOmni1524 ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const buildPCV2 = (0,BuildPCContextV2/* useBuildPCV2 */.s)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const relatedProductHook = (0,RelatedProductContext/* useRelatedProduct */.I)();
    const isEnableNewBuildPCPage = (0,react.useMemo)(()=>{
        return router.pathname.includes("/buildpc") && !!epicOmni1524;
    }, [
        router.pathname,
        epicOmni1524
    ]);
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        cartV2,
        buildPCV2,
        frames,
        showNewProductGift,
        showCtaButtons: isAllowATCFromListing && isEnableNewBuildPCPage,
        showCtaButtonsWithQuantity: isEnableNewBuildPCPage,
        isMobile,
        relatedProductHook
    };
    const _ref = (0,useDiscoverySearch_es/* useDiscoverySearchV2 */.t)(discoveryServiceV2, searchPayload && Object.keys(searchPayload).length ? useSearchProductDiscovery_objectSpreadProps(useSearchProductDiscovery_objectSpread({}, searchPayload), {
        pageSize: 20,
        isReturnProductsBOMSkus: isEnableNewBuildPCPage
    }) : {}, {
        fallbackData: fallbackData,
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, useSearchProductDiscovery_objectSpread({}, discoveryCleanUpConfig)))
            };
        }
    }), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const productList = (0,react.useMemo)(()=>{
        return ((result === null || result === void 0 ? void 0 : result.products) || []).map((p)=>(0,discovery/* createHandleEventAndCtaButton */.D3)(p, useSearchProductDiscovery_objectSpread({}, discoveryCleanUpConfig))).map(transformProductWhenUserUnder18);
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        JSON.stringify(result),
        JSON.stringify(cartV2.flattenItems),
        authLoading, 
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return useSearchProductDiscovery_objectSpread({
        products: productList
    }, rest);
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/VideoPreviewList/VideoPreviewList.tsx
function VideoPreviewList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoPreviewList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VideoPreviewList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const VideoPreviewCarousel = (param)=>{
    let { skus , serverData , as: Comp , asProps  } = param;
    const { addToCart , buyNow  } = useActionButtons();
    const { products , loading  } = useSearchProductDiscovery((skus === null || skus === void 0 ? void 0 : skus.length) ? {
        filter: {
            skus
        }
    } : {}, serverData);
    const injectedProps = {
        productsLoading: loading,
        products,
        addToCart,
        buyNow
    };
    if (!Comp) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, VideoPreviewList_objectSpread({}, asProps, injectedProps));
};
const LazyVideoPreviewCarousel = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPreviewCarousel, VideoPreviewList_objectSpread({}, props))
    });
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/VideoPreviewList/index.ts



/***/ })

}]);